import { useCallback } from 'react';
// Migrated to Paraglide JS - removed useTranslation
import { newConversation } from '@paraglide/messages';
export const useAIChatModalHandlers = ({ isMinimized, setIsMinimized, isMaximized, setIsMaximized, setSize, setPosition, setIsCreatingChat, sendMessage, createChat, clearChatMessages, onClose, handleDragTouchStart, handlePinchStart, currentChatId })=>{
    // Migrated to Paraglide JS - removed useTranslation
    // 터치 핸들러 (드래그 + 핀치 통합)
    const handleTouchStart = useCallback((e)=>{
        if (e.touches.length === 1) {
            handleDragTouchStart(e);
        } else if (e.touches.length === 2) {
            handlePinchStart(e);
        }
    }, [
        handleDragTouchStart,
        handlePinchStart
    ]);
    // 최소화/최대화 토글
    const toggleMinimize = ()=>{
        if (isMinimized) {
            setIsMinimized(false);
        } else {
            // 최소화 시 모달을 완전히 닫고 백그라운드로 이동
            onClose();
        }
    };
    const toggleMaximize = ()=>{
        if (isMaximized) {
            setIsMaximized(false);
            setSize({
                width: 400,
                height: 400
            });
            setPosition({
                x: window.innerWidth - 420,
                y: 100
            });
        } else {
            setIsMaximized(true);
            setSize({
                width: window.innerWidth - 40,
                height: window.innerHeight - 40
            });
            setPosition({
                x: 20,
                y: 20
            });
        }
    };
    const handleSendMessage = async (message, files)=>{
        try {
            await sendMessage(message, files);
        } catch (error) {
            console.error('Failed to send message:', error);
        }
    };
    const handleCreateNewChat = async ()=>{
        setIsCreatingChat(true);
        try {
            await createChat(newConversation());
        } catch (error) {
            console.error('Failed to create chat:', error);
        } finally{
            setIsCreatingChat(false);
        }
    };
    const handleCopyMessage = (content)=>{
        navigator.clipboard.writeText(content).then(()=>{
            console.log('Message copied to clipboard');
        }).catch((err)=>{
            console.error('Failed to copy message:', err);
        });
    };
    const handleClearMessages = async ()=>{
        if (!currentChatId) {
            return;
        }
        try {
            await clearChatMessages(currentChatId);
        } catch (error) {
            console.error('Failed to clear messages:', error);
        }
    };
    return {
        handleTouchStart,
        toggleMinimize,
        toggleMaximize,
        handleSendMessage,
        handleCreateNewChat,
        handleCopyMessage,
        handleClearMessages
    };
};
